module.exports = __webpack_public_path__ + "static/media/Calibre-MediumItalic.4afe8032.woff";